import React from 'react';

import { useDrawer } from '@hooks/useDrawer';

type DrawerChildrenProps = {
  openDrawer: () => void;
  closeDrawer: () => void;
};

interface DrawerListenerProps {
  children: (props: DrawerChildrenProps) => React.ReactNode;
  content: React.ReactNode;
  title: React.ReactNode;
}

function DrawerListener(props: DrawerListenerProps) {
  const { children, content, title } = props;
  const { openDrawer, closeDrawer, setContent, setTitle } = useDrawer();

  const handleOpen = () => {
    setTitle(title);
    setContent(content);
    openDrawer();
  };

  const handleClose = () => {
    closeDrawer();
  };

  return (
    <>
      {children({
        openDrawer: handleOpen,
        closeDrawer: handleClose,
      })}
    </>
  );
}

export default DrawerListener;
